<template>
  <v-overlay
    :model-value="isLoading"
    :absolute="true"
  >
    <v-progress-circular indeterminate />
  </v-overlay>
</template>

<script>
export default {
  // use when part of a page needs to indicate that new data is being submitted or loaded
  name: 'DpplLoader',
  props: { isLoading: { type: Boolean, default: true } },
};
</script>
